import { Button, Box } from '@mui/material';
import { useRouter } from 'next/router';

export const DesktopShortcutButton = () => {
  const router = useRouter();

  return (
    <Button
      fullWidth
      variant="contained"
      onClick={() => router.push('/shortcut')}
      sx={{
        backgroundColor: '#9C27B0',
        color: 'white',
        fontSize: '16px',
        fontWeight: 'bold',
        minHeight: '48px',
        borderRadius: '24px',
        boxShadow: '0 4px 16px rgba(156, 39, 176, 0.3)',
        textTransform: 'none',
        position: 'relative',
        overflow: 'hidden',
        transition: 'all 0.3s ease',
        '&:hover': {
          backgroundColor: '#7B1FA2',
          transform: 'translateY(-1px)',
          boxShadow: '0 6px 20px rgba(156, 39, 176, 0.4)',
        },
        '&:active': {
          transform: 'translateY(0px)',
          boxShadow: '0 2px 8px rgba(156, 39, 176, 0.3)',
        },
        '&::before': {
          content: '""',
          position: 'absolute',
          top: '50%',
          left: '50%',
          width: '0',
          height: '0',
          borderRadius: '50%',
          backgroundColor: 'rgba(255, 255, 255, 0.2)',
          transform: 'translate(-50%, -50%)',
          transition: 'width 0.3s, height 0.3s',
        },
        '&:hover::before': {
          width: '100%',
          height: '100%',
        }
      }}
      startIcon={
        <Box sx={{ fontSize: '20px' }}>📌</Box>
      }
    >
      桌面快捷方式
    </Button>
  );
};
